// extracted by mini-css-extract-plugin
export default {"container":"AddLocation_container__L3FHe","add_form_container":"AddLocation_add_form_container__c5YVc","error_toast":"AddLocation_error_toast__Sm466"};